import * as core from '../../../../../../../core'

import { query } from './save-proposal-domain-row.query'

export const RESOURCE = {
  payload: {
    alias: 'save.proposal.domain.row',
    description:
      'Creates or updates a proposal-domain row from the proposal-domain row edit modal',
    name: 'Save Proposal Domain Row',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
